var map = {
  "./cs.messages.tsx": [
    "13852",
    [
      9360
    ]
  ],
  "./en.messages.tsx": [
    "54817",
    [
      2647
    ]
  ],
  "./sl.messages.tsx": [
    "59809",
    [
      2011
    ]
  ],
  "./hu.messages.tsx": [
    "12217",
    [
      159
    ]
  ],
  "./de.messages.tsx": [
    "85221",
    [
      6379
    ]
  ],
  "./it.messages.tsx": [
    "79199",
    [
      9853
    ]
  ],
  "./pl.messages.tsx": [
    "45102",
    [
      6478
    ]
  ],
  "./sk.messages.tsx": [
    "72020",
    [
      120
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 27577;
module.exports = __rspack_async_context;
